import { ServiceBase } from '../../service/service-base'

export class RelatedProductService extends ServiceBase {
    constructor() {
        super()
    }
}